import { PermissionCode } from '@gb-ticket/shared-types';
import { PlusIcon } from 'lucide-react';
import { Link } from 'react-router';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { adminTableFrameClassName } from '@/platform/features/admin-panel';
import { MasterDataListState } from '@/platform/features/master-data/master-data-list-state';
import { useBusinessPartners } from '@/platform/features/master-data/use-master-data';
import {
  MASTER_DATA_PARTNER_NEW_PATH,
  masterDataPartnerPath,
} from '@/platform/lib/master-data-paths';

export function PartnersPage() {
  const me = useMe();
  const canWrite = hasPermission(me.data, PermissionCode.MASTER_DATA_MANAGE);
  const partners = useBusinessPartners();

  return (
    <section className="space-y-6">
      <PlatformPageHeader
        title="Geschäftspartner"
        description="Lieferanten mit Adressen und Kontakten. Inaktive Partner bleiben für die Historie sichtbar."
        action={
          canWrite ? (
            <Button type="button" asChild>
              <Link to={MASTER_DATA_PARTNER_NEW_PATH}>
                <PlusIcon className="size-4" aria-hidden />
                Geschäftspartner anlegen
              </Link>
            </Button>
          ) : undefined
        }
      />
      <MasterDataListState
        pending={partners.isPending}
        pendingLabel="Geschäftspartner werden geladen …"
        error={partners.isError ? partners.error : null}
        errorLabel="Die Geschäftspartner konnten nicht geladen werden."
        empty={partners.data?.items.length === 0}
        emptyLabel="Noch keine Geschäftspartner."
      >
        <div className={adminTableFrameClassName}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nummer</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {partners.data?.items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="font-mono text-sm">{item.partnerNumber}</TableCell>
                  <TableCell className="font-medium">
                    <Link to={masterDataPartnerPath(item.id)} className="hover:underline">
                      {item.legalName ?? 'Ohne Namen'}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {item.isActive ? (
                      <Badge variant="outline">Aktiv</Badge>
                    ) : (
                      <Badge variant="secondary">inaktiv</Badge>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </MasterDataListState>
    </section>
  );
}
